/**
 * Arguments for CheckMetadata class.
 */
export interface CheckMetadataArgs {
    /**
     * Class to which index is applied.
     */
    target: Function | string

    /**
     * Check constraint name.
     */
    name?: string

    /**
     * Check expression.
     */
    expression: string
}
